import React from "react";
import "./Alert.css";
import { Flex } from "../../layout";
import { TbAlertCircle, TbAlertTriangle, TbInfoCircle } from "react-icons/tb";
import Text from "../typography/Text";

function Alert({ type = "error", text, children, ...props }) {
  return (
    <Flex className={`Alert ${type}`} gap={10} {...props}>
      {type === "error" ? (
        <TbAlertTriangle className="icon" />
      ) : type === "warn" ? (
        <TbAlertCircle className="icon" />
      ) : (
        <TbInfoCircle className="icon" />
      )}
      <Text size="xs">{children || text}</Text>
    </Flex>
  );
}

export default Alert;
